module.exports = __webpack_public_path__ + "assets/back-arrow-new-87efae.svg";